/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.Polynomial"/>
define("SuiteCommerce.PagePrinter.ExtQRCode.Polynomial", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Polynomial = /** @class */ (function () {
        function Polynomial(terms, shift) {
            var offset = 0;
            while (offset < terms.length && terms[offset] == 0) {
                offset++;
            }
            this.coefficients = new Array(terms.length - offset + shift);
            for (var i = 0; i < terms.length - offset; i++) {
                this.coefficients[i] = terms[i + offset];
            }
        }
        Polynomial.prototype.multiply = function (polynomial, qrCode) {
            var terms = new Array(this.coefficients.length + polynomial.coefficients.length - 1);
            for (var i = 0; i < this.coefficients.length; i++) {
                for (var j = 0; j < polynomial.coefficients.length; j++) {
                    terms[i + j] ^= qrCode.getExponential(qrCode.getLogarithm(this.getCoefficient(i)) +
                        qrCode.getLogarithm(polynomial.getCoefficient(j)));
                }
            }
            return new Polynomial(terms, 0);
        };
        Polynomial.prototype.mod = function (polynomial, qrCode) {
            if (this.coefficients.length - polynomial.coefficients.length < 0) {
                return this;
            }
            var ratio = qrCode.getLogarithm(this.getCoefficient(0)) -
                qrCode.getLogarithm(polynomial.getCoefficient(0));
            var terms = new Array(this.coefficients.length);
            for (var i = 0; i < this.coefficients.length; i++) {
                terms[i] = this.getCoefficient(i);
            }
            for (var i = 0; i < polynomial.coefficients.length; i++) {
                terms[i] ^= qrCode.getExponential(qrCode.getLogarithm(polynomial.getCoefficient(i)) + ratio);
            }
            return new Polynomial(terms, 0).mod(polynomial, qrCode);
        };
        Polynomial.prototype.getCoefficient = function (index) {
            return this.coefficients[index];
        };
        return Polynomial;
    }());
    exports.Polynomial = Polynomial;
});
